import Vue from 'vue'
import VueSocialSharing from 'vue-social-sharing'

Vue.use(VueSocialSharing)


// WEBPACK FOOTER //
// ./resources/assets/js/plugins/vueSocialSharing.js